// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-unused-vars, prettier/prettier */
import * as Types from './generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ResourceFieldsFragment = { __typename?: 'Resource', id: string, outfitter_id: string, type: Types.ResourceType, name: string, is_single_use?: boolean | null, capacity?: number | null, year?: number | null, cover_image: string, description?: string | null, created_at: number, updated_at: number, images?: Array<{ __typename?: 'Media', url: string }> | null, vehicle_props?: { __typename?: 'VehicleProps', category: Types.VehicleCategory, make?: string | null, model?: string | null } | null, boat_props?: { __typename?: 'BoatProps', category: Types.BoatCategory, length?: number | null, boat_manufacturer?: string | null, boat_type?: string | null } | null, blind_props?: { __typename?: 'BlindProps', category: Types.BlindCategory } | null, atv_props?: { __typename?: 'AtvProps', category: Types.AtvCategory, manufacturer?: string | null } | null, gear_props?: { __typename?: 'GearProps', other?: string | null } | null };

export type CreateResourceMutationVariables = Types.Exact<{
  data: Types.CreateResourceInput;
}>;


export type CreateResourceMutation = { __typename?: 'Mutation', createResource: { __typename?: 'Resource', id: string, outfitter_id: string, type: Types.ResourceType, name: string, is_single_use?: boolean | null, capacity?: number | null, year?: number | null, cover_image: string, description?: string | null, created_at: number, updated_at: number, images?: Array<{ __typename?: 'Media', url: string }> | null, vehicle_props?: { __typename?: 'VehicleProps', category: Types.VehicleCategory, make?: string | null, model?: string | null } | null, boat_props?: { __typename?: 'BoatProps', category: Types.BoatCategory, length?: number | null, boat_manufacturer?: string | null, boat_type?: string | null } | null, blind_props?: { __typename?: 'BlindProps', category: Types.BlindCategory } | null, atv_props?: { __typename?: 'AtvProps', category: Types.AtvCategory, manufacturer?: string | null } | null, gear_props?: { __typename?: 'GearProps', other?: string | null } | null } };

export type DeleteResourceMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeleteResourceMutation = { __typename?: 'Mutation', deleteResource?: any | null };

export type UpdateResourceMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  data: Types.UpdateResourceInput;
}>;


export type UpdateResourceMutation = { __typename?: 'Mutation', updateResource: { __typename?: 'Resource', id: string, outfitter_id: string, type: Types.ResourceType, name: string, is_single_use?: boolean | null, capacity?: number | null, year?: number | null, cover_image: string, description?: string | null, created_at: number, updated_at: number, images?: Array<{ __typename?: 'Media', url: string }> | null, vehicle_props?: { __typename?: 'VehicleProps', category: Types.VehicleCategory, make?: string | null, model?: string | null } | null, boat_props?: { __typename?: 'BoatProps', category: Types.BoatCategory, length?: number | null, boat_manufacturer?: string | null, boat_type?: string | null } | null, blind_props?: { __typename?: 'BlindProps', category: Types.BlindCategory } | null, atv_props?: { __typename?: 'AtvProps', category: Types.AtvCategory, manufacturer?: string | null } | null, gear_props?: { __typename?: 'GearProps', other?: string | null } | null } };

export type ResourcesByOutfitterQueryVariables = Types.Exact<{
  outfitterId: Types.Scalars['String']['input'];
}>;


export type ResourcesByOutfitterQuery = { __typename?: 'Query', resourcesByOutfitter: Array<{ __typename?: 'Resource', id: string, outfitter_id: string, type: Types.ResourceType, name: string, is_single_use?: boolean | null, capacity?: number | null, year?: number | null, cover_image: string, description?: string | null, created_at: number, updated_at: number, images?: Array<{ __typename?: 'Media', url: string }> | null, vehicle_props?: { __typename?: 'VehicleProps', category: Types.VehicleCategory, make?: string | null, model?: string | null } | null, boat_props?: { __typename?: 'BoatProps', category: Types.BoatCategory, length?: number | null, boat_manufacturer?: string | null, boat_type?: string | null } | null, blind_props?: { __typename?: 'BlindProps', category: Types.BlindCategory } | null, atv_props?: { __typename?: 'AtvProps', category: Types.AtvCategory, manufacturer?: string | null } | null, gear_props?: { __typename?: 'GearProps', other?: string | null } | null }> };

export type ResourceQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type ResourceQuery = { __typename?: 'Query', resource: { __typename?: 'Resource', id: string, outfitter_id: string, type: Types.ResourceType, name: string, is_single_use?: boolean | null, capacity?: number | null, year?: number | null, cover_image: string, description?: string | null, created_at: number, updated_at: number, images?: Array<{ __typename?: 'Media', url: string }> | null, vehicle_props?: { __typename?: 'VehicleProps', category: Types.VehicleCategory, make?: string | null, model?: string | null } | null, boat_props?: { __typename?: 'BoatProps', category: Types.BoatCategory, length?: number | null, boat_manufacturer?: string | null, boat_type?: string | null } | null, blind_props?: { __typename?: 'BlindProps', category: Types.BlindCategory } | null, atv_props?: { __typename?: 'AtvProps', category: Types.AtvCategory, manufacturer?: string | null } | null, gear_props?: { __typename?: 'GearProps', other?: string | null } | null } };

export const ResourceFieldsFragmentDoc = gql`
    fragment ResourceFields on Resource {
  id
  outfitter_id
  type
  name
  images {
    url
  }
  is_single_use
  capacity
  year
  vehicle_props {
    category
    make
    model
  }
  boat_props {
    category
    length
    boat_manufacturer
    boat_type
  }
  blind_props {
    category
  }
  atv_props {
    category
    manufacturer
  }
  gear_props {
    other
  }
  cover_image
  description
  created_at
  updated_at
}
    `;
export const CreateResourceDocument = gql`
    mutation createResource($data: CreateResourceInput!) {
  createResource(data: $data) {
    ...ResourceFields
  }
}
    ${ResourceFieldsFragmentDoc}`;
export type CreateResourceMutationFn = Apollo.MutationFunction<CreateResourceMutation, CreateResourceMutationVariables>;

/**
 * __useCreateResourceMutation__
 *
 * To run a mutation, you first call `useCreateResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createResourceMutation, { data, loading, error }] = useCreateResourceMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateResourceMutation(baseOptions?: Apollo.MutationHookOptions<CreateResourceMutation, CreateResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateResourceMutation, CreateResourceMutationVariables>(CreateResourceDocument, options);
      }
export type CreateResourceMutationHookResult = ReturnType<typeof useCreateResourceMutation>;
export type CreateResourceMutationResult = Apollo.MutationResult<CreateResourceMutation>;
export type CreateResourceMutationOptions = Apollo.BaseMutationOptions<CreateResourceMutation, CreateResourceMutationVariables>;
export const DeleteResourceDocument = gql`
    mutation deleteResource($id: ID!) {
  deleteResource(id: $id)
}
    `;
export type DeleteResourceMutationFn = Apollo.MutationFunction<DeleteResourceMutation, DeleteResourceMutationVariables>;

/**
 * __useDeleteResourceMutation__
 *
 * To run a mutation, you first call `useDeleteResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResourceMutation, { data, loading, error }] = useDeleteResourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteResourceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteResourceMutation, DeleteResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteResourceMutation, DeleteResourceMutationVariables>(DeleteResourceDocument, options);
      }
export type DeleteResourceMutationHookResult = ReturnType<typeof useDeleteResourceMutation>;
export type DeleteResourceMutationResult = Apollo.MutationResult<DeleteResourceMutation>;
export type DeleteResourceMutationOptions = Apollo.BaseMutationOptions<DeleteResourceMutation, DeleteResourceMutationVariables>;
export const UpdateResourceDocument = gql`
    mutation updateResource($id: ID!, $data: UpdateResourceInput!) {
  updateResource(id: $id, data: $data) {
    ...ResourceFields
  }
}
    ${ResourceFieldsFragmentDoc}`;
export type UpdateResourceMutationFn = Apollo.MutationFunction<UpdateResourceMutation, UpdateResourceMutationVariables>;

/**
 * __useUpdateResourceMutation__
 *
 * To run a mutation, you first call `useUpdateResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResourceMutation, { data, loading, error }] = useUpdateResourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateResourceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResourceMutation, UpdateResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResourceMutation, UpdateResourceMutationVariables>(UpdateResourceDocument, options);
      }
export type UpdateResourceMutationHookResult = ReturnType<typeof useUpdateResourceMutation>;
export type UpdateResourceMutationResult = Apollo.MutationResult<UpdateResourceMutation>;
export type UpdateResourceMutationOptions = Apollo.BaseMutationOptions<UpdateResourceMutation, UpdateResourceMutationVariables>;
export const ResourcesByOutfitterDocument = gql`
    query resourcesByOutfitter($outfitterId: String!) {
  resourcesByOutfitter(outfitterId: $outfitterId) {
    ...ResourceFields
  }
}
    ${ResourceFieldsFragmentDoc}`;

/**
 * __useResourcesByOutfitterQuery__
 *
 * To run a query within a React component, call `useResourcesByOutfitterQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcesByOutfitterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcesByOutfitterQuery({
 *   variables: {
 *      outfitterId: // value for 'outfitterId'
 *   },
 * });
 */
export function useResourcesByOutfitterQuery(baseOptions: Apollo.QueryHookOptions<ResourcesByOutfitterQuery, ResourcesByOutfitterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourcesByOutfitterQuery, ResourcesByOutfitterQueryVariables>(ResourcesByOutfitterDocument, options);
      }
export function useResourcesByOutfitterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourcesByOutfitterQuery, ResourcesByOutfitterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourcesByOutfitterQuery, ResourcesByOutfitterQueryVariables>(ResourcesByOutfitterDocument, options);
        }
export type ResourcesByOutfitterQueryHookResult = ReturnType<typeof useResourcesByOutfitterQuery>;
export type ResourcesByOutfitterLazyQueryHookResult = ReturnType<typeof useResourcesByOutfitterLazyQuery>;
export type ResourcesByOutfitterQueryResult = Apollo.QueryResult<ResourcesByOutfitterQuery, ResourcesByOutfitterQueryVariables>;
export const ResourceDocument = gql`
    query resource($id: String!) {
  resource(id: $id) {
    ...ResourceFields
  }
}
    ${ResourceFieldsFragmentDoc}`;

/**
 * __useResourceQuery__
 *
 * To run a query within a React component, call `useResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResourceQuery(baseOptions: Apollo.QueryHookOptions<ResourceQuery, ResourceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceQuery, ResourceQueryVariables>(ResourceDocument, options);
      }
export function useResourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceQuery, ResourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceQuery, ResourceQueryVariables>(ResourceDocument, options);
        }
export type ResourceQueryHookResult = ReturnType<typeof useResourceQuery>;
export type ResourceLazyQueryHookResult = ReturnType<typeof useResourceLazyQuery>;
export type ResourceQueryResult = Apollo.QueryResult<ResourceQuery, ResourceQueryVariables>;